import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d00c4ae2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d00c4ae2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00c4ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d00c4ae2')) {
      api.createRecord('d00c4ae2', component.options)
    } else {
      api.reload('d00c4ae2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d00c4ae2&scoped=true", function () {
      api.rerender('d00c4ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/order/GoodsInfoTab/index.vue"
export default component.exports